import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from 'axios';
// import moment from 'moment';
import echarts from 'echarts';
Vue.prototype.$echarts = echarts;
// Vue.prototype.$moment = moment;//赋值使用
// moment.locale('zh-cn');//需要汉化

Vue.config.productionTip = false;
Vue.prototype.$http = axios;

import {
  Image,
  Button,
  Row,
  Col,
  Tabs,
  TabPane,
  Breadcrumb,
  BreadcrumbItem,
  Radio,
  Select,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  RadioGroup,
  // RadioButton,
  Checkbox,
  // CheckboxButton,
  CheckboxGroup,
  Progress,
  Upload,
  Form,
  FormItem,
  Input,
  InputNumber,
  Option,
  OptionGroup,
  Table,
  TableColumn,
  Pagination,
  Dialog,
  Avatar,
  MessageBox,
  Message,
  Collapse,
  CollapseItem,
  DatePicker,
  TimePicker,
  Loading,
  Alert,
  Divider,
  Tooltip
} from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

Vue.component(Button.name, Button);
Vue.component(Select.name, Select);
Vue.use(Image);
Vue.use(Row);
Vue.use(Col);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Radio);
Vue.use(RadioGroup);
// Vue.use(RadioButton);
Vue.use(Checkbox);
// Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Progress);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Upload);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Avatar);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(DatePicker);
Vue.use(TimePicker);
Vue.use(Tooltip);
Vue.use(Alert);
Vue.use(Divider);
Vue.use(Loading.directive);

Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = Message;
Vue.prototype.$loading = Loading.service;
Vue.prototype.$alert = MessageBox.alert;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
